import Button from '@codegouvfr/react-dsfr/Button';
import { useConfig } from '@common/config';
import React from 'react';
import { FrSuccessIcon } from "./components/FrSucessIcon";

export const CampagneTerminee = () => {
  const { getConfigValue } = useConfig();

  const handleNavigateTo = (url: string) => window.location.href = url;

  return (
    <div className="min-h-screen p-4 flex h-screen" style={{ height: '100vh' }}>

      <div className="flex flex-col w-full">
        <div className="fr-grid-row fr-grid-row--center fr-grid-row--gutters w-full justify-center"
             style={{ margin: 'auto' }}>
          <div className="fr-server__body fr-col-12 fr-col-md-6">
            <h1 className="fr-h1">{'La campagne est désormais terminée.'}</h1>
            <p className="fr-text--xl">{'Il n\'est plus possible de s\'inscrire.'}</p>
            <p className="fr-text--xl">{'Vous pouvez consulter votre déclaration ici :'}</p>
            <div className={'flex gap-2'}>
              <Button onClick={() => handleNavigateTo(getConfigValue('PARCOURS_OFA_URL'))}>{'Parcours OFA'}</Button>
            </div>
          </div>
          <FrSuccessIcon />
        </div>
      </div>
    </div>
  );
};
